export var AnnouncementType;
(function (AnnouncementType) {
    AnnouncementType["BrandingUpdate"] = "BrandingUpdate";
    AnnouncementType["ReactApp"] = "ReactApp";
    AnnouncementType["GettingToKnowYou"] = "GettingToKnowYou";
    AnnouncementType["MyContentMigration"] = "MyContentMigration";
    AnnouncementType["OCDIBanner"] = "OCDIBanner";
    AnnouncementType["OCDIBannerMCM"] = "OCDIBannerMCM";
    AnnouncementType["OCDIBannerCCM"] = "OCDIBannerCCM";
    AnnouncementType["OCDIComingSoon"] = "OCDIComingSoon";
})(AnnouncementType || (AnnouncementType = {}));
export var ANNOUNCEMENT_DISMISS_WEB_STATE_USER_STORAGE_KEY = 'AnnouncementDismissWebData';
export var ANNOUNCEMENT_DISMISS_DESKTOP_STATE_USER_STORAGE_KEY = 'AnnouncementDismissDesktopData';
//# sourceMappingURL=AnnouncementTypes.js.map